import { render, staticRenderFns } from "./el-list-page.vue?vue&type=template&id=0fe8314b&scoped=true"
import script from "./el-list-page.vue?vue&type=script&lang=js"
export * from "./el-list-page.vue?vue&type=script&lang=js"
import style0 from "./el-list-page.vue?vue&type=style&index=0&id=0fe8314b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe8314b",
  null
  
)

export default component.exports